<!-- Human Composition -->
<template>
  <HcListPopPage
    v-if="isPopupVisible"
    :shop-data="selectedShopData"
    @close="closePopup"
  />
  <div class="hc-list-page">
    <div class="hc-list-header">
      <div>
        <button
          v-if="userInfo && userInfo.OGN_FG === '00'"
          @click="toggleDetailView"
          class="detail-view-btn"
        >
          {{ isDetailView ? "상세접기" : "상세보기" }}
        </button>
        <button @click="toggleToView" class="to-view-btn">
          {{ isToView ? "TO인원수수료닫기" : "TO인원수수료보기" }}
        </button>
        <button @click="toggleRateView" class="rate-view-btn">
          {{ isRateView ? "매장평점닫기" : "매장평점보기" }}
        </button>
      </div>
      <span class="header-title">( {{ currentDate }} 인적구성 )</span>
      <button
        v-if="['판매전쟁실', '상품관리본부', '관리자팀'].includes(this.userInfo.EMP_DEPT_NM)"
        class="hcList-button"
        @click="copyShopListData"
      >
        복사
      </button>
    </div>
    <div class="hc-grids-container">
      <!-- 좌측 그리드 -->
      <div class="hc-list-section" style="flex: 7.9">
        <ag-grid-vue
          class="ag-hc-balham shopList-grid"
          :columnDefs="shopListColumnDefs"
          :rowData="shopListData"
          :gridOptions="gridOptions"
          :theme="theme"
          :rowHeight="rowHeight"
          :pinnedTopRowData="shopListPinnedTopRowData"
          @grid-ready="shopListGridReady"
        />
      </div>

      <!-- 우측 그리드 -->
      <div class="hc-list-section" style="flex: 2.1">
        <ag-grid-vue
          class="ag-hc-balham branchList-grid"
          :columnDefs="branchListColumnDefs"
          :rowData="branchListData"
          :gridOptions="gridOptions"
          :theme="theme"
          :rowHeight="rowHeight"
          :pinnedTopRowData="branchListPinnedTopRowData"
          @grid-ready="branchListGridReady"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";
import HcListPopPage from "./HcListPopPage.vue";

export default {
  name: "HcListPage",
  components: { AgGridVue, HcListPopPage },
  props: {
    useNewGrid: Boolean,
  },
  emits: ["top-info-change"],
  data() {
    return {
      isPopupVisible: false, // 팝업 표시 상태
      selectedShopData: null, // 팝업에 전달할 데이터
      isDetailView: false, // 상세보기 상태
      // isToView: false, // TO인원수수료보기 상태
      isRateView: false, // 매장평점보기 상태
      currentDate: "", // 오늘 날짜를 저장할 데이터 속성
      userInfo: null, // 로그인 사용자 정보
      rowHeight: window.innerWidth > 1024 ? 25 : 22, // 행 높이

      // isDetailView의 초기값을 userInfo에 따라 설정합니다.
      isToView: (() => {
        const userInfoString = localStorage.getItem("userInfo");
        if (!userInfoString) return false;
        const userInfo = JSON.parse(userInfoString);
        return userInfo && userInfo.OGN_FG !== "00";
      })(),

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      branchListData: [],
      branchListColumnDefs: [
        {
          headerName: "NO",
          field: "topRoW",
          valueGetter: (params) => {
            if (params.node.rowPinned === "top") return "합계";
            return params.node.rowIndex + 1;
          },
          minWidth: 19,
          width: 19,
          flex: 0.6,
          cellStyle: this.branchListCellStyle,
          colSpan: (params) => {
            if (params.node.rowPinned === "top") {
              return 2;
            }
            return 1;
          },
        },
        {
          headerName: "본부",
          field: "BRANCH_NM",
          flex: 0.8,
          cellStyle: this.branchListCellStyle,
        },
        {
          headerName: "월TO",
          field: "lM_TO",
          flex: 1.2,
          cellStyle: this.branchListCellStyle,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "재직",
          field: "lSV",
          flex: 1.2,
          cellStyle: this.branchListCellStyle,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "근무",
          field: "lWK",
          flex: 1.2,
          cellStyle: this.branchListCellStyle,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "적합",
          field: "lSuc",
          flex: 0.9,
          cellStyle: this.branchListCellStyle,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
        {
          headerName: "부적합",
          field: "lFal",
          flex: 0.9,
          cellStyle: this.branchListCellStyle,
          valueFormatter: (params) => {
            return Number(params.value || 0).toLocaleString();
          },
        },
      ],
      branchListPinnedTopRowData: [],
      branchListTopCalcSum() {
        if (!this.branchListData || this.branchListData.length === 0) return;

        const averages = {
          BRANCH_NM: "",
          lM_TO: 0,
          lSV: 0,
          lWK: 0,
          lSuc: 0,
          lFal: 0,
          BRANCH_CD: "",
        };

        // 평균 계산
        this.branchListData.forEach((row) => {
          averages.lM_TO += Number(row.lM_TO || 0);
          averages.lSV += Number(row.lSV || 0);
          averages.lWK += Number(row.lWK || 0);
          averages.lSuc += Number(row.lSuc || 0);
          averages.lFal += Number(row.lFal || 0);
        });

        // pinnedTopRowData 업데이트
        this.branchListPinnedTopRowData = [averages];
      },

      shopListGridApi: null,
      shopListData: [],
      shopListPinnedTopRowData: [],
      shopListTopCalcSum() {
        if (!this.shopListData || this.shopListData.length === 0) return;

        const sums = {
          lM_TO: 0,
          lTO: 0,
          total: 0,
          suc: 0,
          fal: 0,
          lServe: 0,
          lCEO_SV: 0,
          lSM_SV: 0,
          lM_SV: 0,
          lAM_SV: 0,
          lA_SV: 0,
          lS_SV: 0,
          lWK: 0,
          lCEO_WK: 0,
          lSM_WK: 0,
          lM_WK: 0,
          lAM_WK: 0,
          lA_WK: 0,
          lS_WK: 0,
          THIS_OK: 0,
          THIS_09: 0,
          THIS_12: 0,
          THIS_15: 0,
          THIS_18: 0,
          MON_OK: 0,
          EXP_FEE: 0, // 예상수수료 (MON_OK * 4)
        };

        // 합계 계산
        this.shopListData.forEach((row) => {
          for (const key in sums) {
            if (key === "EXP_FEE") {
              sums.EXP_FEE += Number(row.MON_OK || 0) * 4;
            } else if (row[key]) {
              sums[key] += Number(row[key] || 0);
            }
          }
        });

        this.shopListPinnedTopRowData = [sums];
      },

      gridOptions: {
        headerHeight: 50,
        groupHeaderHeight: 25, // 그룹 헤더의 높이를 25px로 설정합니다.
        rowHeight: 22,
        suppressHorizontalScroll: false,
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        tooltipShowMode: "whenTruncated",
        enableBrowserTooltips: false,
        tooltipShowDelay: 0,
        components: {
          // lCheck 컬럼을 위한 커스텀 셀 렌더러 등록
          lCheckCellRenderer: this.lCheckCellRenderer,
        },
        defaultColDef: {
          wrapHeaderText: true,
          sortable: true,
          resizable: false,
          tooltipValueGetter: (params) => params.value,
          headerStyle: {
            color: "black",
            textAlign: "center",
            alignContent: "center",
          },
        },
      },
    };
  },

  created() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }
    // isToView의 초기값을 userInfo에 따라 설정합니다.
    // 본사/관리자('00')는 '보기'로, 그 외에는 '닫기'로 시작합니다.
    if (this.userInfo && this.userInfo.OGN_FG !== "00") {
      this.isToView = true; // 'TO인원수수료닫기'
    }
    //20260616 오류 만 쌓여서 검색만 안되게 막음 
    // this.fetchData();
  },

  methods: {
    toggleDetailView() {
      this.isDetailView = !this.isDetailView;
    },
    toggleToView() {
      this.isToView = !this.isToView;
    },
    toggleRateView() {
      this.isRateView = !this.isRateView;
    },
    // 오늘 날짜를 'YYYY-MM-DD' 형식으로 설정하는 메소드
    setCurrentDate() {
      const now = new Date();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      this.currentDate = `${month}월${day}일`;
    },
    async fetchData() {
      // --- 사용자 권한에 따라 shopList 조회 파라미터를 설정합니다. ---
      let shopListParams = { index: 1, value: "" }; // 기본값
      if (this.userInfo) {
        const { OGN_FG, EMP_CLASS_NM, BRANCH_CD, SHOP_CD } = this.userInfo;
        if (OGN_FG === "00") {
          // 본사/관리자
          if (EMP_CLASS_NM === "본부장" && BRANCH_CD !== "") {
            shopListParams = { index: 2, value: BRANCH_CD };
          } else {
            shopListParams = { index: 1, value: "" };
          }
        } else {
          // 매장 사용자
          shopListParams = { index: 3, value: SHOP_CD };
        }
      }

      try {
        const [shopListRes, branchListRes] = await Promise.all([
          axios.get("/api/hcListPage/shopList", {
            params: shopListParams,
            timeout: 60000,
          }),
          axios.get("/api/hcListPage/branchList"),
        ]);

        this.shopListData = shopListRes.data;
        this.branchListData = branchListRes.data;
        this.branchListTopCalcSum();
        this.shopListTopCalcSum();
      } catch (error) {
        console.error("데이터 로딩 실패:", error);
      }
    },

    branchListCellStyle(params) {
      const style = {};
      const field = params.colDef.field;

      // 상단 고정 행 스타일
      if (params.node.rowPinned === "top") {
        style.backgroundColor = "#ffe4e1";
        // '합계' 텍스트는 병합된 셀의 중앙에 위치
        if (field === "topRoW" || field === "BRANCH_NM") {
          style.textAlign = "center";
        } else {
          style.textAlign = "right";
        }
        return style;
      }

      // 일반 행 스타일
      if (field === "topRoW" || field === "BRANCH_NM") {
        style.textAlign = "center"; // 'NO', '본부' 컬럼은 가운데 정렬
      } else {
        style.textAlign = "right"; // 나머지 컬럼은 오른쪽 정렬
      }
      return style;
    },

    shopListCellStyle(params) {
      const style = {};
      const field = params.colDef.field;
      const centerAlignFields = [
        "VAN_BIZ_NO",
        "SHOP_NM",
        "sAppro",
        "sN1",
        "sP1",
        "sN2",
        "sP2",
        "sN3",
        "sP3",
        "sN4",
        "sP4",
        "sN5",
        "sP5",
        "sN6",
        "sP6",
        "sN7",
        "sP7",
        "sN8",
        "sP8",
        "sN9",
        "sP9",
        "sN10",
        "sP10",
      ];

      if (centerAlignFields.includes(field)) {
        style.textAlign = "center";
      } else {
        style.textAlign = "right";
      }

      // 상단 고정 행 스타일
      if (params.node.rowPinned === "top") {
        style.backgroundColor = "#ffe1df";
        style.borderColor = "#FF0000";
      }

      if (
        field == "lServe" ||
        field == "lWK" ||
        field == "MON_OK" ||
        field == "EST_FEE"
      ) {
        style.borderColor = "#FF0000";
      }

      if (field == "sAppro") {
        style.color = params.value == "부합" ? "#ff0000" : "#000000";
      }

      // sS[n] 값에 따라 sP[n], sN[n] 글자색 변경
      const staffMatch = field.match(/^(s[NP])(\d{1,2})$/);
      if (staffMatch && params.data) {
        const staffIndex = staffMatch[2];
        const statusField = `sS${staffIndex}`;
        const status = params.data[statusField];

        if (status === "휴무") {
          style.color = "#aaaaaa"; // '휴무'일 때 빨간색
        } else if (status === "근무") {
          style.color = "#000000"; // '근무'일 때 검정색
        }
      }

      if (
        (field == "VAN_BIZ_NO" ||
          field == "SHOP_NM" ||
          field == "lM_TO" ||
          field == "lTO" ||
          field == "sAppro" ||
          field == "lCheck") &&
        params.node.rowPinned !== "top"
      ) {
        style.backgroundColor = "#d1e6fe";
      }

      if (field == "lScore" && params.node.rowPinned !== "top") {
        style.backgroundColor = "#ffff00";
      }

      if (
        (field == "sP2" ||
          field == "sN2" ||
          field == "sP4" ||
          field == "sN4" ||
          field == "sP6" ||
          field == "sN6" ||
          field == "sP8" ||
          field == "sN8") &&
        params.node.rowPinned !== "top"
      ) {
        style.backgroundColor = "#eaeaea";
      }

      if (
        (field == "sP9" ||
          field == "sN9" ||
          field == "sP10" ||
          field == "sN10") &&
        params.node.rowPinned !== "top"
      ) {
        style.backgroundColor = "#b5ffb5";
      }

      if (
        (field == "total" ||
          field == "suc" ||
          field == "fal" ||
          field == "lServe" ||
          field == "lCEO_SV" ||
          field == "lSM_SV" ||
          field == "lM_SV" ||
          field == "lAM_SV" ||
          field == "lA_SV" ||
          field == "lS_SV") &&
        params.node.rowPinned !== "top"
      ) {
        style.backgroundColor = "#f3fcb6";
      }

      if (
        (field == "lWK" ||
          field == "lCEO_WK" ||
          field == "lSM_WK" ||
          field == "lM_WK" ||
          field == "lAM_WK" ||
          field == "lA_WK" ||
          field == "lS_WK") &&
        params.node.rowPinned !== "top"
      ) {
        style.backgroundColor = "#c6fec5";
      }

      if ((field == "lServe" || field == "lWK") && params.value < 1) {
        style.backgroundColor = "#ff0000";
      }

      if (field == "THIS_OK" && params.node.rowPinned === "top") {
        style.backgroundColor = "#fbce33";
      } else if (field == "THIS_OK") {
        style.backgroundColor = "#fcda63";
      }

      if (
        (field == "THIS_09" ||
          field == "THIS_12" ||
          field == "THIS_15" ||
          field == "THIS_18") &&
        params.node.rowPinned === "top"
      ) {
        style.backgroundColor = "#ffff8c";
      } else if (
        field == "THIS_09" ||
        field == "THIS_12" ||
        field == "THIS_15" ||
        field == "THIS_18"
      ) {
        style.backgroundColor = "#ffffc8";
      }

      if (
        (field == "MON_OK" || field == "EST_FEE") &&
        params.node.rowPinned === "top"
      ) {
        style.backgroundColor = "#f295a0"; // 상단 고정 행일 때의 색상
      } else if (field == "MON_OK" || field == "EST_FEE") {
        style.backgroundColor = "#f9ced3";
      }

      return style;
    },

    handleResize() {
      const isWide = window.innerWidth > 1024;
      const newRowHeight = isWide ? 25 : 22;
      if (this.rowHeight !== newRowHeight) {
        this.rowHeight = newRowHeight;
        if (this.gridApi) this.gridApi.resetRowHeights();
      }
    },

    shopListGridReady(params) {
      this.shopListGridApi = params.api;
      this.increaseGridApi = params.api;
    },

    branchListGridReady(params) {
      this.decreaseGridApi = params.api;
    },

    async onLCheckButtonClick(action, data) {
      if (action === "입력" || action === "수정") {
        const index = action === "입력" ? 5 : 6;
        const shopCd = data.SHOP_CD;

        try {
          const response = await axios.get("/api/hcListPage/popupData", {
            params: { index, shopCd },
          });

          // 기존 행 데이터(data)에 DB에서 조회한 직원 목록(employees)을 추가합니다.
          this.selectedShopData = {
            ...data,
            employees: response.data || [],
          };
          this.isPopupVisible = true;
        } catch (error) {
          console.error("팝업 데이터 조회 실패:", error);
          alert("데이터를 불러오는 중 오류가 발생했습니다.");
        }
      } else if (action === "확인") {
        if (confirm(`'${data.SHOP_NM}' 매장을 확인 처리하시겠습니까?`)) {
          try {
            await axios.post("/api/hcListPage/confirmLCheck", {
              shopCd: data.SHOP_CD,
            });
            alert("확인 처리되었습니다.");
            this.fetchData(); // 그리드 데이터 새로고침
          } catch (error) {
            console.error("확인 처리 실패:", error);
            alert("확인 처리 중 오류가 발생했습니다.");
          }
        }
      } else {
        console.log(`Action: ${action}, Data:`, data);
        alert(`${action} 버튼 클릭: ${data.SHOP_NM}`);
      }
    },
    lCheckCellRenderer(params) {
      if (!params.data || !this.userInfo) return null;

      const lCheckValue = params.data.lCheck;
      const { OGN_FG, SHOP_CD, EMP_CLASS_NM, EMP_NM, BRANCH_CD } = this.userInfo;
      const rowShopCd = params.data.SHOP_CD;

      const createButton = (text) => {
        const button = document.createElement("button");
        button.innerText = text;
        button.style.width = "100%";
        button.style.height = "100%";
        button.style.padding = "0";
        button.style.fontSize = "0.7rem";
        button.addEventListener("click", () =>
          this.onLCheckButtonClick(text, params.data)
        );
        return button;
      };

      const createTextSpan = (text, color) => {
        const span = document.createElement("span");
        span.innerText = text;
        if (color) {
          span.style.color = color;
        }
        return span;
      };

      if (lCheckValue == 0 && OGN_FG !== "00" && SHOP_CD == rowShopCd) {
        return createButton("입력");
      } else if (lCheckValue == 0 && OGN_FG === "00") {
        return createTextSpan(" ", "red");
      } else if (
        lCheckValue == 1 &&
        ((OGN_FG === "00" && EMP_CLASS_NM === "본부장" && BRANCH_CD !=="") || EMP_NM === "관리자")
      ) {
        return createButton("확인");
      } else if (
        lCheckValue == 1 &&
        OGN_FG === "00" &&
        EMP_CLASS_NM !== "본부장"
      ) {
        return createTextSpan(" ", "blue"); // "확인대기" 대신 공백
      } else if (lCheckValue == 1 && OGN_FG !== "00" && SHOP_CD == rowShopCd) {
        return createButton("수정");
      } else if (lCheckValue == 2) {
        return createTextSpan("완료", "black");
      }

      return createTextSpan(""); // 기본값 (아무것도 표시하지 않음)
    },
    closePopup(isSaved) {
      this.isPopupVisible = false;
      this.selectedShopData = null;
      // 팝업에서 저장이 완료된 경우, 메인 그리드 데이터를 새로고침합니다.
      if (isSaved) {
        this.fetchData();
      }
    },

    copyShopListData() {
      this.copyData(this.shopListGridApi);
    },
    copyData(gridApi) {
      const csvData = gridApi.getDataAsCsv({
        // 헤더 가공: \n 제거
        processHeaderCallback: (params) => {
          const def = params.column.getColDef();
          const header = def.headerName ?? def.field ?? "";
          return String(header).replace(/\r?\n/g, " "); // 줄바꿈 → 공백
        },
        // 셀 값 가공(필요하면): 셀 안의 줄바꿈도 제거
        processCellCallback: (params) => {
          const v = params.value;
          if (v == null) return "";
          return String(v).replace(/\r?\n/g, " ");
        },
        // 엑셀 친화 옵션
        columnSeparator: "\t", // 탭 구분 → 엑셀에 바로 셀 분리
        suppressQuotes: true, // 큰따옴표 억제(헤더에 따옴표 생기는 문제 방지)
      });

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => alert("복사되었습니다."))
          .catch((err) => console.error("Clipboard copy failed: ", err));
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = csvData;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("복사되었습니다.");
      }
    },
  },
  computed: {
    shopListColumnDefs() {
      const baseColumns = [
        {
          headerName: "",
          valueGetter: (params) => {
            if (params.node.rowPinned === "top") return "";
            return params.node.rowIndex + 1;
          },
          width: 30,
          flex: 0.8,
          pinned: "left",
          cellStyle: {
            textAlign: "center",
            backgroundColor: "#a0caf3",
          },
        },
        {
          headerName: "점번",
          field: "VAN_BIZ_NO",
          width: 30,
          flex: 0.8,
          pinned: "left",
          cellStyle: this.shopListCellStyle,
        },
        {
          headerName: "점명",
          field: "SHOP_NM",
          width: 75,
          flex: 1.7,
          pinned: "left",
          valueGetter: (params) => {
            if (params.node.rowPinned === "top") {
              return "";
            }
            return params.data.SHOP_NM;
          },
          cellStyle: this.shopListCellStyle,
        },
        {
          headerName: "TO",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "기준",
              field: "lM_TO",
              width: 42,
              flex: 1.1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              pinned: "left",
              cellStyle: this.shopListCellStyle,
            },
            {
              headerName: "요일",
              field: "lTO",
              width: 42,
              flex: 1.1,
              pinned: "left",
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
            },
          ],
        },
        {
          headerName: "적합",
          field: "lScore",
          width: 15,
          flex: 0.8,
          pinned: "left",
          cellStyle: this.shopListCellStyle,
        },
        {
          headerName: "평가",
          field: "sAppro",
          width: 50,
          flex: 1,
          pinned: "left",
          cellStyle: this.shopListCellStyle,
        },
        {
          headerName: "확인",
          field: "lCheck",
          width: 35,
          flex: 1,
          pinned: "left",
          cellRenderer: "lCheckCellRenderer",
          cellStyle: this.shopListCellStyle,
          tooltipValueGetter: () => null, // 툴팁 비활성화
        },
      ];

      const monthlyAggregation = {
        headerName: "월별집계",
        headerStyle: {
          color: "black",
          backgroundColor: "#a0caf3",
          textAlign: "center",
        },
        children: [
          {
            headerName: "전체",
            field: "total",
            minWidth: 50,
            flex: 1,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
            hide: !this.isDetailView,
          },
          {
            headerName: "적합",
            field: "suc",
            minWidth: 50,
            flex: 1,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
            hide: !this.isDetailView,
          },
          {
            headerName: "부적합",
            field: "fal",
            minWidth: 50,
            flex: 1,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
            hide: !this.isDetailView,
          },
        ],
      };

      const incumbent = {
        headerName: "재직",
        headerStyle: {
          color: "black",
          backgroundColor: "#a0caf3",
          textAlign: "center",
        },
        children: [
          {
            headerName: "전체",
            field: "lServe",
            minWidth: 45,
            flex: 1,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
          },
          {
            headerName: "사업주",
            field: "lCEO_SV",
            minWidth: 50,
            flex: 0.8,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
            hide: !this.isDetailView,
          },
          {
            headerName: "차장",
            field: "lSM_SV",
            minWidth: 40,
            flex: 0.8,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
            hide: !this.isDetailView,
          },
          {
            headerName: "과장",
            field: "lM_SV",
            minWidth: 40,
            flex: 0.8,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
            hide: !this.isDetailView,
          },
          {
            headerName: "대리",
            field: "lAM_SV",
            minWidth: 40,
            flex: 0.8,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
            hide: !this.isDetailView,
          },
          {
            headerName: "주임",
            field: "lA_SV",
            minWidth: 40,
            flex: 0.8,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
            hide: !this.isDetailView,
          },
          {
            headerName: "기사",
            field: "lS_SV",
            minWidth: 40,
            flex: 0.8,
            valueFormatter: (params) => {
              return Number(params.value || 0).toLocaleString();
            },
            cellStyle: this.shopListCellStyle,
            hide: !this.isDetailView,
          },
        ],
      };

      const remainingColumns = [
        {
          headerName: "근무",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "전체",
              field: "lWK",
              minWidth: 45,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
            },
            {
              headerName: "사업주",
              field: "lCEO_WK",
              minWidth: 50,
              flex: 0.8,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isDetailView,
            },
            {
              headerName: "차장",
              field: "lSM_WK",
              minWidth: 40,
              flex: 0.8,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isDetailView,
            },
            {
              headerName: "과장",
              field: "lM_WK",
              minWidth: 40,
              flex: 0.8,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isDetailView,
            },
            {
              headerName: "대리",
              field: "lAM_WK",
              minWidth: 40,
              flex: 0.8,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isDetailView,
            },
            {
              headerName: "주임",
              field: "lA_WK",
              minWidth: 40,
              flex: 0.8,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isDetailView,
            },
            {
              headerName: "기사",
              field: "lS_WK",
              minWidth: 40,
              flex: 0.8,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isDetailView,
            },
          ],
        },
        {
          headerName: "매장평점",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "네이버평점",
              field: "NaverSC",
              minWidth: 50,
              flex: 1,
              valueFormatter: (params) => Number(params.value || 0).toFixed(1),
              cellStyle: this.shopListCellStyle,
              hide: !this.isRateView,
            },
            {
              headerName: "다음평점",
              field: "DaumSC",
              minWidth: 50,
              valueFormatter: (params) => Number(params.value || 0).toFixed(1),
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: !this.isRateView,
            },
          ],
        },
        {
          headerName: "사업주",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "이름",
              field: "sN1",
              minWidth: 55,
              flex: 1.2,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "직원1",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "직급",
              field: "sP2",
              minWidth: 45,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
            {
              headerName: "이름",
              field: "sN2",
              minWidth: 55,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "직원2",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "직급",
              field: "sP3",
              minWidth: 45,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
            {
              headerName: "이름",
              field: "sN3",
              minWidth: 55,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "직원3",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "직급",
              field: "sP4",
              minWidth: 45,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
            {
              headerName: "이름",
              field: "sN4",
              minWidth: 55,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "직원4",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "직급",
              field: "sP5",
              minWidth: 45,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
            {
              headerName: "이름",
              field: "sN5",
              minWidth: 55,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "직원5",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "직급",
              field: "sP6",
              minWidth: 45,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
            {
              headerName: "이름",
              field: "sN6",
              minWidth: 55,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "직원6",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "직급",
              field: "sP7",
              minWidth: 45,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
            {
              headerName: "이름",
              field: "sN7",
              minWidth: 55,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "직원7",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "직급",
              field: "sP8",
              minWidth: 45,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
            {
              headerName: "이름",
              field: "sN8",
              minWidth: 55,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "파견1",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "직급",
              field: "sP9",
              minWidth: 45,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
            {
              headerName: "이름",
              field: "sN9",
              minWidth: 55,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "파견2",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "직급",
              field: "sP10",
              minWidth: 45,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
            {
              headerName: "이름",
              field: "sN10",
              minWidth: 55,
              flex: 1,
              cellStyle: this.shopListCellStyle,
              hide: this.isToView,
            },
          ],
        },
        {
          headerName: "당일결과",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "충족여부",
              field: "THIS_OK",
              minWidth: 60,
              flex: 1.2,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isToView,
            },
            {
              headerName: "1차",
              field: "THIS_09",
              minWidth: 45,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isToView,
            },
            {
              headerName: "2차",
              field: "THIS_12",
              minWidth: 45,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isToView,
            },
            {
              headerName: "3차",
              field: "THIS_15",
              minWidth: 45,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isToView,
            },
            {
              headerName: "4차",
              field: "THIS_18",
              minWidth: 45,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isToView,
            },
          ],
        },
        {
          headerName: "당월충족",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "충족횟수",
              field: "MON_OK",
              minWidth: 60,
              flex: 1.2,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isToView,
            },
            {
              headerName: "예상수수료(만)",
              field: "EST_FEE",
              minWidth: 70,
              flex: 1.5,
              valueGetter: (params) => {
                if (params.node.rowPinned === "top") return params.data.EXP_FEE;
                if (!params.data) return 0;
                return (params.data.MON_OK || 0) * 4;
              },
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.shopListCellStyle,
              hide: !this.isToView,
            },
          ],
        },
      ];

      return [
        ...baseColumns,
        monthlyAggregation,
        incumbent,
        ...remainingColumns,
      ];
    },
  },

  mounted() {
    this.setCurrentDate(); // 컴포넌트 마운트 시 오늘 날짜 설정
    window.addEventListener("resize", this.handleResize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.hc-list-page {
  font-family: "Malgun Gothic", Arial, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 2px 2px;
  height: 97%;
}

.hc-grids-container {
  display: flex; /* Arrange grids horizontally */
  gap: 10px; /* Gap between the two grids */
  flex: 1; /* Allow this container to grow and take available vertical space */
}

.hc-list-header {
  text-align: center;
  white-space: nowrap;
  font-size: 1.2rem;
}

.hc-list-header .detail-view-btn {
  float: left;
  background-color: #ffff00;
}
.hc-list-header .to-view-btn,
.hc-list-header .rate-view-btn {
  float: left;
  background-color: #f0f0f0;
}

.header-title {
  font-weight: bold;
  margin-right: 55px;
}

.hc-list-section {
  border: none;
  background-color: #f9f9f9;
}

:deep(.ag-hc-balham) {
  height: calc(100vh - 120px);
  --ag-cell-horizontal-padding: 3px; /* 셀 내부 좌우 패딩 */
  /* --ag-header-height: 30px;
  --ag-row-height: 25px;
  --ag-header-background-color: #f0f0f0;
  --ag-odd-row-background-color: #ffffff;
  --ag-even-row-background-color: #f8f8f8; */
}

/* 상위 40위 그리드 헤더 배경색 */
:deep(.shopList-grid .ag-header-cell) {
  background-color: #a0caf3;
}

/* 하위 40위 그리드 헤더 배경색 */
:deep(.branchList-grid .ag-header-cell) {
  background-color: #c0ffff;
}

:deep(.ag-hc-balham .ag-header-cell-comp-wrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.ag-header-cell-label) {
  justify-content: center;
}

:deep(.ag-hc-balham.shopList-grid .ag-cell) {
  font-size: 0.75rem;
}

:deep(.ag-hc-balham.branchList-grid .ag-cell) {
  font-size: 0.7rem;
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-hc-balham.shopList-grid .ag-cell) {
    font-size: 0.9rem;
  }

  :deep(.ag-hc-balham.branchList-grid .ag-cell) {
    font-size: 0.9rem;
  }
}
</style>
